import { useCallback, useEffect, useState } from "react";
import ToggleSwitch from "../../../../components/toggleSwitch";
import { dayPack, hipPack, travelPack } from "./utils";
import { BASE_URL_IMAGE } from "../../../../services/ApiEndpoints";
import Cropper from "react-easy-crop";
import { dataURLtoBlob, getCroppedImg } from '../../../../utils/helpers';
export default function WidgetManagerBottom({ onSubmit, onBack, widgetData, setWidgetData, isSubmitting }) {
    const [errors, setErrors] = useState({});
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    const [bottomWidget, setBottomWidget] = useState({
        keyName: null,
        currentFile: null,
        isModalOpen: false,
    })
    const updateState = (key, value) => {
        setBottomWidget((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };
    const handleInputChange = (key, field, value) => {
        setWidgetData((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                [field]: value,
            },
        }));
    };

    const togglePro = (key) => {
        setWidgetData((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                type: prev[key].type === "pro" ? "regular" : "pro",
            },
        }));
    };
    const validate = () => {
        // if (input.trim() === '') {
        //     setError('This field is required.');
        //     return false;
        // }
        // setError('');
        return true;
    };
    useEffect(() => {
        let newErrors = { ...errors };

        Object.keys(widgetData).forEach((key) => {
            if (widgetData[key].type === "pro" && widgetData[key][`${key}Image`]) {
                delete newErrors[key]; // Remove error if image is provided
            }
        });

        setErrors(newErrors); // Update errors state
    }, [widgetData]);
    const handleSubmit = () => {
        let newErrors = {};

        // Check each item in widgetData
        Object.keys(widgetData).forEach((key) => {
            if (widgetData[key].type === "pro" && !widgetData[key][`${key}Image`]) {
                newErrors[key] = `${key} Image Required`;
            }
        });

        if (Object.keys(newErrors).length === 0) {
            onSubmit({ widgetData }, validate());
        } else {
            setErrors(newErrors); // Store errors in state
        }
    };

    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            updateState("currentFile", file)
            updateState("isModalOpen", true)
            reader.readAsDataURL(file);
            // reader.onload = () => {
            //     // setImageSrc(reader.result);
            //     setIsModalOpen(true);
            // };
        }
    };

    const triggerFileInput = (key) => {
        updateState("keyName", key)
    };

    const handleCrop = async () => {
        try {
            if (!croppedAreaPixels) {
                throw new Error("Crop area is not set properly.");
            }
            const imageSrc = URL.createObjectURL(bottomWidget?.currentFile)


            const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);

            // Clean up memory
            URL.revokeObjectURL(imageSrc);

            if (!croppedImage) {
                throw new Error("Failed to process cropped image.");
            }


            // Convert Base64 to Blob
            // const blob = dataURLtoBlob(croppedImage);
            // if (!blob) {
            //     throw new Error("Failed to convert cropped image to Blob.");
            // }

            // Convert Blob to File
            const file = new File([croppedImage], "cropped-image.png", { type: "image/png" });

            // Ensure file size is reasonable
            if (file.size > 5 * 1024 * 1024) { // 5MB limit
                throw new Error("Cropped image is too large. Please crop a smaller area.");
            }
            handleInputChange(bottomWidget.keyName, `${bottomWidget.keyName}Image`, file);
            updateState("currentFile", null);
            updateState("isModalOpen", false);

        } catch (error) {
            console.error("Error during cropping:", error.message);
            alert(error.message); // Show error message to user
        }
    };

    return (
        <div className="max-w-[1000px] !mx-auto space-y-6 bg-white p-8 mt-10">
            <div className="grid grid-cols-2 gap-5 p-4">
                {Object.keys(widgetData).filter(key => key !== "tags" && key !== "tripLength" && key !== "activities" && key !== "widgets").map((key, index) => (
                    <div
                        key={key}

                    >
                        <div className={`rounded-xl shadow-md text-dark p-4 ${widgetData[key]?.type === "pro" ? "bg-orange " : "bg-bgprimary "
                            }`}>
                            <h2 className="text-center font-bold font-roboto-mono text-lg mb-2">
                                {widgetData[key]?.type === "pro" ? widgetData[key]?.name : key.charAt(0).toUpperCase() + key.slice(1)}
                            </h2>
                        </div>
                        <div className="border border-bgprimary p-4 bg-white rounded-xl mt-4 min-h-48">
                            <div className="text-right flex justify-end items-center gap-5 mb-3">
                                <label className="flex items-center ">
                                    <ToggleSwitch checked={widgetData[key]?.type === "pro"} onChange={() => togglePro(key)} disabled={index === 0} />
                                    {/* <input
                                type="checkbox"
                                checked={widgetData[key].type === "pro"}
                                onChange={() => togglePro(key)}
                                className="mr-2"
                            /> */}
                                </label>
                                <span className="font-bold font-roboto-mono text-xl" >
                                    PRO
                                </span>
                            </div>

                            {widgetData[key]?.type === "pro" ? (
                                <div className="flex flex-col gap-3" >
                                    <input
                                        type="text"
                                        placeholder="Enter Name"
                                        value={widgetData[key].name || ""}
                                        onChange={(e) => handleInputChange(key, "name", e.target.value.replace(/^\s+/, ""))} // Removes leading spaces
                                        className="border border-bgprimary text-[#1F2937AB] font-medium text-[16px] font-quicksand rounded-md p-2 w-full"
                                    />
                                    {/* <input
                                        type="file"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                handleInputChange(
                                                    key,
                                                    `${key}Image`, // Adjust this key if needed
                                                    file // Pass binary data (Uint8Array)
                                                );
                                            }
                                        }}
                                        className="border border-bgprimary text-[#1F2937AB] font-medium text-[16px] font-quicksand rounded-md p-2 w-full"
                                    /> */}
                                    <input
                                        type="file"
                                        id="current-img"
                                        className="hidden"
                                        onChange={onFileChange}
                                    />
                                    <label
                                        htmlFor="current-img"
                                        onClick={() => triggerFileInput(key)}
                                        className="border border-bgprimary text-[#1F2937AB] font-medium text-[16px] font-quicksand rounded-md p-2 w-full"
                                    >
                                        Upload Image
                                    </label>
                                    {widgetData[key]?.[`${key}Image`] && (
                                        <img
                                            src={
                                                typeof widgetData[key][`${key}Image`] === "string"
                                                    ? `${BASE_URL_IMAGE}${widgetData[key][`${key}Image`]}`
                                                    : URL.createObjectURL(widgetData[key][`${key}Image`]) // Handle file object
                                            }
                                            alt={key}
                                            className="w-full h-32 object-cover rounded-md mb-2"
                                        />
                                    )}
                                    {errors[key] && (
                                        <p className="text-red-600 text-[12px]">{errors[key]}</p>
                                    )}
                                    <input
                                        type="text"
                                        placeholder="Enter URL"
                                        value={widgetData[key].url}
                                        onChange={(e) => handleInputChange(key, "url", e.target.value.replace(/^\s+/, ""))}
                                        className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Enter Description"
                                        value={widgetData[key].description}
                                        onChange={(e) => {
                                            let value = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                                            value = value.substring(0, 185);
                                            handleInputChange(key, "description", value);
                                        }}
                                        className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                    />
                                    <div className="flex justify-end text-right" >{widgetData[key]?.description?.length || 0}/185</div>
                                </div>
                            ) : (
                                <>
                                    <select
                                        value={widgetData[key]?.size}
                                        onChange={(e) => handleInputChange(key, "size", e.target.value)}
                                        className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                    >
                                        <option >Select Size</option>
                                        {(index == 1 ? travelPack : index == 2 ? dayPack : hipPack).map((item, index) => {
                                            return (
                                                <option key={index} value={item}>{item}</option>
                                            )
                                        })}
                                        <option value="None">None</option>

                                    </select>

                                </>

                            )}
                        </div>
                    </div>
                ))}
            </div>
            <div className="flex justify-end gap-4 mt-4">

                <button onClick={onBack} className="px-4 py-2 bg-aths text-dark font-roboto-mono font-bold rounded">Back</button>

                <button onClick={handleSubmit} className="px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded" disabled={isSubmitting} > {isSubmitting == true ? 'Submitting ...' : 'Submit'}</button>

            </div>



            {bottomWidget?.isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-[350px] h-[600px] relative">
                        <h2 className="text-lg font-bold mb-2">Crop Your Image</h2>
                        <div className="crop-container h-[200px] w-full">
                            <Cropper
                                image={URL.createObjectURL(bottomWidget.currentFile)}
                                crop={crop}
                                zoom={zoom}
                                aspect={4 / 3}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                                style={{ height: "200px", width: "100%" }}
                            />
                        </div>
                        <div className="controls">
                            <input
                                type="range"
                                value={zoom}
                                min={0.5}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                onChange={(e) => {
                                    setZoom(e.target.value)
                                }}
                                className="zoom-range"
                            />
                        </div>

                        <div className="flex justify-end space-x-2 mt-4 absolute bottom-4 left-[35%] translate-x-[-50%] w-full">
                            <button className="px-4 py-2 bg-gray-400 text-dark rounded border border-bgprimary" onClick={() => updateState("isModalOpen", false)}>
                                Cancel
                            </button>
                            <button className="px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded" onClick={handleCrop}>
                                Crop & Save
                            </button>
                        </div>



                    </div>
                </div>
            )}
        </div>


    );
}
